import useModalStore from '@/stores/modal.store';

export interface LoadingModalProps {
  title: string;
  message: string;
}

export default function LoadingModal({ message, title }: LoadingModalProps) {
  const close = useModalStore((state) => state.close);

  return (
    <>
      <div className="mb-4 text-center">
        {/* Spinner */}
        <div className="inline-flex my-4">
          <div
            aria-hidden
            role="status"
            aria-live="polite"
            aria-busy="true"
            className="size-16 animate-spin rounded-full border-8 border-gray-200 border-t-violet-500"
          />
        </div>
        <div className="text-lg font-semibold text-gray-800 dark:text-gray-100">{title}</div>
      </div>

      {/* Modal content */}
      <div className="text-center">
        <div className="text-sm mb-5">{message}</div>

        <button
          className="font-medium text-md text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition hover:underline"
          onClick={(e) => {
            e.preventDefault();
            close();
          }}
        >
          Avbryt
        </button>
      </div>
    </>
  );
}
